<div class="notification-content__trim" aria-hidden="true"></div>

<div class="notification-content__message" matSnackBarLabel>{{ data.message }}</div>

@if (data.dismissLabel) {
    <div class="notification-content__actions" matSnackBarActions>
        <button matButton matSnackBarAction (click)="onClick_dismiss()">{{ data.dismissLabel }}</button>
    </div>
}
